<template>
  <el-dialog
    title="填写联系人信息"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="clearAcceptInvitationDialog"
    class="dialog accept-invitation-dialog"
    width="50rem"
  >
    <el-form
      ref="acceptForm"
      :model="acceptForm"
      :rules="acceptRules"
      label-width="120px"
      class="flex-center flex-column"
      label-suffix="："
      size="small"
    >
      <el-form-item label="企业名称" class="detail-item">
        <div class="company-name">
          {{ companyName }}
        </div>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactUserName">
        <el-input
          v-model="acceptForm.contactUserName"
          placeholder="请输入联系人姓名"
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="联系人手机" prop="contactUserPhone">
        <el-input
          v-model.trim="acceptForm.contactUserPhone"
          placeholder="请输入联系人手机"
          maxlength="11"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="联系人邮箱" prop="contactUserEmail">
        <el-input
          v-model.trim="acceptForm.contactUserEmail"
          placeholder="请输入联系人邮箱"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="clearAcceptInvitationDialog"
      >取 消</el-button>
      <el-button
        type="primary"
        @click="acceptInvitation"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AcceptInvitationDialog',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      require: true
    },

    acceptInvitationFun: {
      type: Function,
      default: acceptForm => {}
    }
  },

  data() {
    return {
      acceptForm: {
        contactUserName: '',
        contactUserPhone: '',
        contactUserEmail: ''
      },

      acceptRules: {
        contactUserName: {
          required: true,
          message: '请输入联系人姓名',
          trigger: 'blur'
        },
        contactUserPhone: [
          {
            required: true,
            message: '请输入联系人手机',
            trigger: 'blur'
          },
          {
            pattern: /^\d{11}$/,
            message: '请输入正确的11位手机号',
            trigger: 'blur'
          }
        ],
        contactUserEmail: [
          {
            required: true,
            message: '请输入联系人邮箱',
            trigger: 'blur'
          },
          {
            pattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
            message: '请输入正确的电子邮箱格式',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    ...mapState('company', ['companyId', 'companyName']),
    ...mapState('user', ['mobile', 'employeeName', 'employeeEmail'])
  },

  watch: {
    employeeName(val) {
      this.acceptForm.contactUserName = val
    },
    mobile(val) {
      this.acceptForm.contactUserPhone = val
    },
    employeeEmail(val) {
      this.acceptForm.contactUserEmail = val
    }
  },

  created() {
    this.acceptForm.contactUserName = this.employeeName
    this.acceptForm.contactUserPhone = this.mobile
    this.acceptForm.contactUserEmail = this.employeeEmail
  },

  activated() {
    this.acceptForm.contactUserName = this.employeeName
    this.acceptForm.contactUserPhone = this.mobile
    this.acceptForm.contactUserEmail = this.employeeEmail
  },

  methods: {
    clearAcceptInvitationDialog() {
      // 对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$refs.acceptForm.resetFields()
      this.$emit('change', !this.showDialog)
    },

    acceptInvitation() {
      this.$refs.acceptForm.validate(valid => {
        if (!valid) return

        this.acceptInvitationFun(
          Object.assign({}, this.acceptForm, {
            supplierId: this.companyId,
            supplierName: this.companyName
          })
        )
          .then(res => {
            this.clearAcceptInvitationDialog()
          })
          .catch(err => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

::v-deep .el-input {
  width: pixel-to-rem($n: 360);
}
.company-name {
  width: pixel-to-rem($n: 360);
  font-size: pixel-to-rem($n: 20);
  color: $text-color;
}
</style>
